var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"bc-layout",class:_vm.appClasses},[_vm._t("default"),_c('QuickInfoLayer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }